import { faSignOut, faUser } from "@fortawesome/free-solid-svg-icons";
import {
    faLayerGroup,
    faObjectsColumn,
    faUsers,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Avatar,
    Box,
    IconButton,
    MenuItem,
    MenuProps,
    Menu as MuiMenu,
    styled,
    Typography,
    useTheme,
} from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { mutationLogout } from "src/api/auth";
import { MapContext } from "src/contexts/map";
import {
    URL_CATEGORY_SETTINGS,
    URL_LOGIN,
    URL_MAP_SETTINGS,
    URL_USER_SETTINGS,
} from "src/router/routes";

const Menu = styled(MuiMenu)<MenuProps>(() => ({
    marginTop: 2,
    display: "flex",
    alignItems: "center",
}));

const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
    borderRadius: 50,
    backgroundColor: theme.palette.secondary.main,
    padding: 8,
}));

const MenuIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    height: theme.spacing(2),
    width: theme.spacing(2),
}));

const UserManger = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const { isAuthenticated } = useContext(MapContext);
    const { schema } = useParams<{ schema: string }>();
    const navigate = useNavigate();

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        isAuthenticated
            ? setAnchorEl(event.currentTarget as unknown as HTMLElement)
            : navigate(`/${schema}${URL_LOGIN}`);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { mutateAsync: mutateLogout } = mutationLogout();

    const handleLogout = () => {
        mutateLogout(sessionStorage.getItem("authToken") || "");
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("currentZoom");
        sessionStorage.removeItem("currentCenter");
        navigate(`/${schema}${URL_LOGIN}`);
    };

    const { t } = useTranslation();

    const theme = useTheme();

    const handleMenuItemClick = (path: string) => {
        navigate(`/${schema}${path}`);
        handleClose();
    };

    return (
        <Box>
            <IconButton disableRipple onClick={handleClick}>
                {!isAuthenticated ? (
                    <Icon color={theme.palette.common.white} icon={faUser} />
                ) : (
                    <Avatar alt="Logo" src="/static/images/person.png" />
                )}
            </IconButton>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                    onClick={() => handleMenuItemClick(URL_USER_SETTINGS)}
                >
                    <MenuIcon icon={faUsers} />
                    <Typography ml={1}>{t("user.manage")}</Typography>
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick(URL_MAP_SETTINGS)}>
                    <MenuIcon icon={faLayerGroup} />
                    <Typography ml={1}>{t("maps.manage")}</Typography>
                </MenuItem>
                <MenuItem
                    onClick={() => handleMenuItemClick(URL_CATEGORY_SETTINGS)}
                >
                    <MenuIcon icon={faObjectsColumn} />
                    <Typography ml={1}>{t("category.manage")}</Typography>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        handleLogout();
                        handleClose();
                    }}
                >
                    <MenuIcon icon={faSignOut} />
                    <Typography ml={1}>{t("logout")}</Typography>
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default UserManger;
